module.exports = __webpack_public_path__ + "img/nf.c3e8898d.svg";